import React from 'react';
import { UsersIcon, ClockIcon, ChurchIcon } from 'lucide-react';
export function EventDetails() {
  return <section id="kdaj" className="py-20 px-6 scroll-mt-24 relative bg-olive/[0.06]" data-id="element-14">
      <div className="max-w-xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-17">Kdaj?</h2>
          <p className="font-serif italic text-olive/80 text-xl" data-id="element-18">
            Nedelja, 5. 7. 2026
          </p>
          <div className="w-16 h-px bg-gold/50 mx-auto mt-6" data-id="element-19"></div>
        </div>

        {/* PRIMARY — the gathering everyone is invited to */}
        <div className="flex flex-col items-center text-center space-y-5 p-8 md:p-10 bg-white/60 rounded-sm border border-gold/30 shadow-sm" data-id="element-20">
          <div className="w-14 h-14 rounded-full bg-olive flex items-center justify-center text-ivory shadow-sm" data-id="element-21">
            <UsersIcon size={26} strokeWidth={1.5} data-id="element-22" />
          </div>
          <div data-id="element-23">
            <div className="flex items-center justify-center gap-2 text-gold font-sans text-sm tracking-widest uppercase mb-3" data-id="element-24">
              <ClockIcon size={16} data-id="element-25" />
              <span data-id="element-26">Od 13.00 dalje</span>
            </div>
            <h3 className="text-3xl mb-3" data-id="element-27">Piknik in druženje</h3>
            
          </div>
        </div>

        {/* SECONDARY — optional regular Sunday mass */}
        <div className="mt-6 flex items-start gap-4 p-6 bg-transparent rounded-sm border border-dashed border-olive/20" data-id="element-28">
          <div className="w-10 h-10 flex-shrink-0 rounded-full bg-ivory flex items-center justify-center text-olive/70 shadow-sm" data-id="element-29">
            <ChurchIcon size={20} strokeWidth={1.5} data-id="element-30" />
          </div>
          <div className="text-left" data-id="element-31">
            <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-32">
              <span className="font-serif text-xl text-olive" data-id="element-33">
                Sveta maša ob 10.00
              </span>
              <span className="font-sans text-[11px] tracking-widest uppercase text-gold border border-gold/40 rounded-full px-2 py-0.5" data-id="element-34">
                neobvezno
              </span>
            </div>
            <p className="font-sans text-soft-brown/80 leading-relaxed" data-id="element-35">
              Z družino se bomo udeležili redne nedeljske maše v cerkvi na{' '}
              <span className="font-medium text-olive" data-id="element-36">Raki</span>. Če se nam
              želite pridružiti, ste prisrčno vabljeni — sicer pa se vidimo na
              placu od 13.00 dalje.
            </p>
          </div>
        </div>
      </div>
    </section>;
}